var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13970_60484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 29C12.5 29 3.75 17.5875 3.75 12.75C3.75 11.6009 3.97633 10.4631 4.41605 9.40152C4.85578 8.33992 5.5003 7.37533 6.31282 6.56282C7.12533 5.7503 8.08992 5.10578 9.15152 4.66605C10.2131 4.22633 11.3509 4 12.5 4C13.6491 4 14.7869 4.22633 15.8485 4.66605C16.9101 5.10578 17.8747 5.7503 18.6872 6.56282C19.4997 7.37533 20.1442 8.33992 20.5839 9.40152C21.0237 10.4631 21.25 11.6009 21.25 12.75C21.25 17.5875 12.5 29 12.5 29Z",
    fill: "#717780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.122 9.59286L20.5839 9.40152L20.122 9.59286C20.5366 10.5938 20.75 11.6666 20.75 12.75C20.75 13.8411 20.2467 15.3754 19.4301 17.1177C18.6223 18.8412 17.5407 20.7016 16.4525 22.4217C15.3653 24.1402 14.2773 25.7097 13.4607 26.8501C13.0667 27.4003 12.7362 27.85 12.5 28.1679C12.2638 27.85 11.9333 27.4003 11.5393 26.8501C10.7227 25.7097 9.63468 24.1402 8.54754 22.4217C7.45932 20.7016 6.37775 18.8412 5.56993 17.1177C4.7533 15.3754 4.25 13.8411 4.25 12.75C4.25 11.6666 4.46339 10.5938 4.87799 9.59286C5.2926 8.59193 5.90029 7.68245 6.66637 6.91637C7.43245 6.15029 8.34193 5.5426 9.34286 5.12799C10.3438 4.71339 11.4166 4.5 12.5 4.5C13.5834 4.5 14.6562 4.71339 15.6571 5.12799C16.6581 5.5426 17.5675 6.15029 18.3336 6.91637C19.0997 7.68245 19.7074 8.59193 20.122 9.59286Z",
    stroke: "#717780"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3498 17.463V14.0694H13.6575V17.463H16.5421V12.9382H18.2728L12.5036 7.84766L6.73438 12.9382H8.46514V17.463H11.3498Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13970_60484",
    x: 1.75,
    y: 0,
    width: 25.5,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13970_60484"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13970_60484",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5a6ad81c632faa73ad1f37cb060610b5.svg";
export { ForwardRef as ReactComponent };